import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const coverageStylingChange = z.object({
  /** Dot-path of the styling field on the team document. */
  path: z.string(),
  /** Destination's current value, JSON-stringified (empty string if unset). */
  before: z.string(),
  /** Source's value that would be written, JSON-stringified (empty if unset). */
  after: z.string(),
});
export type CoverageStylingChange = z.infer<typeof coverageStylingChange>;

export const copyCoverageStyling = unaryRpc({
  name: "copyCoverageStyling",
  input: z.object({
    sourceTeamId: zExt.objectId(),
    destinationTeamId: zExt.objectId(),
    /** When true, compute the diff but do not write anything. */
    dryRun: z.boolean(),
  }),
  output: z.object({
    success: z.boolean(),
    message: z.string(),
    sourceTeamName: z.string().optional(),
    destinationTeamName: z.string().optional(),
    /** Only the fields whose value actually differs between the two teams. */
    changes: z.array(coverageStylingChange),
    /**
     * Full destination team document as it was BEFORE applying, JSON-stringified.
     * Download this so the change can be reverted if needed.
     */
    backup: z.string().optional(),
  }),
});
